export default __webpack_public_path__ + "static/media/Tabl_19.2596a1f0.svg";